import { useMutation } from 'react-query'
import { getFileAPI } from 'framework/api/http'

interface GetOrdersExportCsvInterface {
  from?: string
  principle?: any
  to?: string
}
export const useGetFileVsCustomerOrderExportCSV = () => {
  const mutate = useMutation(
    ({ from, principle, to }: GetOrdersExportCsvInterface) => {
      // BDL20-2286: streamed text/csv download — request as a blob.
      return getFileAPI(
        `/FileVsCustomerOrder/CsvList?&Principle=${
          principle?.value === 'All' ? '' : principle?.value
        }&To=${to}&From=${from}`,
      )
    },
  )
  return mutate
}
export default GetOrdersExportCsvInterface
